import { Video } from "@/machines/types/video";

export function findVideoForTimestamp(
  videos: Video[],
  timestamp: number
): { video: Video; index: number } | null {
  for (let i = 0; i < videos.length; i++) {
    const start = new Date(videos[i].start_time).getTime();
    const end = new Date(videos[i].end_time).getTime();
    if (timestamp >= start && timestamp <= end) {
      return { video: videos[i], index: i };
    }
  }

  let closestIndex = 0;
  let minDiff = Infinity;
  for (let i = 0; i < videos.length; i++) {
    const start = new Date(videos[i].start_time).getTime();
    const diff = Math.abs(timestamp - start);
    if (diff < minDiff) {
      minDiff = diff;
      closestIndex = i;
    }
  }

  return videos.length > 0 ? { video: videos[closestIndex], index: closestIndex } : null;
}

export function computeSeekPosition(
  videoStartTime: string,
  selectedTime: number
): number {
  const startMs = new Date(videoStartTime).getTime();
  return (selectedTime - startMs) / 1000;
}

export function computeAbsoluteTimestamp(
  videoStartTime: string,
  currentTimeSeconds: number
): number {
  return new Date(videoStartTime).getTime() + currentTimeSeconds * 1000;
}
